import styled from "styled-components";

export const RecurrenceModalsParent=styled.div`

`